<template>
  <div class="atividades-monitoramentoescala ml-4 mr-4">
    <b-form>
      <b-row>
        <b-col cols="1" class="mt-2 pr-4">
          <b-form-group label="" label-for="tabela-foto">
            <b-img
              class="mb-2"
              v-model="operador.foto_url"
              v-bind="mainProps"
              rounded
              alt="Foto"
              :src="operador.foto_url"
            >
            </b-img>
          </b-form-group>
        </b-col>

        <b-col>
          <!-- NOME -->
          <b-row>
            <b-col cols="5" class="mt-3">
              <b-form-input
                id="fot-nome"
                type="text"
                readonly
                v-model="operador.nome"
                placeholder="Nome funcionário"
              />
            </b-col>

            <b-col cols="3" class="mt-3">
              <b-form-input
                id="fot-funcao"
                type="text"
                readonly
                v-model="operador.funcao"
                placeholder="Função"
              />
            </b-col>
          </b-row>

          <!-- Resumo -->

          <!-- RE e CELULAR -->
          <b-row>
            <b-col cols="1" class="mt-4">
              <b-form-input
                id="fot-registro"
                type="text"
                required
                v-model="registro"
                @keyup.enter="loadOperador()"
                placeholder="1818"
              />
            </b-col>

            <b-col cols="2" class="mt-4">
              <div>
                <b-form-datepicker
                  id="esc_data_servico"
                  required
                  v-model="data_inicial"
                  placeholder="Data inicial"
                  locale="pt-BR"
                  date-format-options="DD/MM/YYYY"
                ></b-form-datepicker>
              </div>
            </b-col>

            <b-col cols="2" class="mt-4">
              <div>
                <b-form-datepicker
                  id="esc_data_servico2"
                  required
                  v-model="data_final"
                  placeholder="Data final"
                  locale="pt-BR"
                  date-format-options="DD/MM/YYYY"
                ></b-form-datepicker>
              </div>
            </b-col>

            <b-col cols="1" class="mt-4">
              <b-button
                size="sm"
                id="btn-pesquisar"
                variant="primary"
                class="mr-2 mt-2"
                :disabled="carregando"
                @click="(carregando = true), loadFichaPonto()"
              >
                <b-spinner v-if="carregando" small style="margin-bottom: 3px">
                </b-spinner>
                Pesquisar
              </b-button>
            </b-col>

            <b-col cols="1" class="mt-4">
              <b-button
                size="sm"
                id="btn-gerarpdf2"
                variant="warning"
                class="mr-2 mt-2"
                @click="gerarPDFLesser()"
              >
                Gerar Pdf
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-form>

    <hr />

    <!-- Tabela de dados -->
    <b-table
      ref="tblGridFichaPonto"
      small
      hover
      striped
      sticky-header="862px"
      :items="fichaponto"
      :fields="fields"
    >
      <!-- Customização da célula com a foto -->
      <template v-slot:cell(foto0)="data">
        <div v-if="data.item.dt_servico">
          <p>
            {{
              moment(data.item.dt_servico)
                .format("DD/MM/YYYY")
                .replace("Data inválida", "-")
            }}
          </p>
        </div>
      </template>

      <!-- Customização das células com as fotos -->
      <template v-slot:cell(foto1)="data">
        <div v-if="data.item.nsr_array[0]">
          <img
            :src="data.item.nsr_array[0][1]"
            alt="Foto"
            style="max-width: 140px; max-height: 140px"
          />
          <p>
            {{
              moment(data.item.nsr_array[0][0])
                .format("DD/MM/YYYY HH:mm")
                .replace("Data inválida", "")
            }}
          </p>
        </div>
      </template>

      <template v-slot:cell(foto2)="data">
        <div v-if="data.item.nsr_array[1]">
          <img
            :src="data.item.nsr_array[1][1]"
            alt="Foto"
            style="max-width: 140px; max-height: 140px"
          />
          <p>
            {{
              moment(data.item.nsr_array[1][0])
                .format("DD/MM/YYYY HH:mm")
                .replace("Data inválida", "")
            }}
          </p>
        </div>
      </template>

      <template v-slot:cell(foto3)="data">
        <div v-if="data.item.nsr_array[2]">
          <img
            :src="data.item.nsr_array[2][1]"
            alt="Foto"
            style="max-width: 140px; max-height: 140px"
          />
          <p>
            {{
              moment(data.item.nsr_array[2][0])
                .format("DD/MM/YYYY HH:mm")
                .replace("Data inválida", "")
            }}
          </p>
        </div>
      </template>

      <template v-slot:cell(foto4)="data">
        <div v-if="data.item.nsr_array[3]">
          <img
            :src="data.item.nsr_array[3][1]"
            alt="Foto"
            style="max-width: 140px; max-height: 140px"
          />
          <p>
            {{
              moment(data.item.nsr_array[3][0])
                .format("DD/MM/YYYY HH:mm")
                .replace("Data inválida", "")
            }}
          </p>
        </div>
      </template>

      <!-- Continue para as demais células de fotos -->
    </b-table>
  </div>
</template>



<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import moment from "moment";
import { mapState } from "vuex";
import Header from "./Header.vue";
//import fs from 'fs';
//import pdf from 'html-pdf';
//import moment from 'moment';
//port html2pdf from 'html2pdf.js';
import jsPDF from "jspdf";
import "jspdf-autotable";

//const PDFDocument = require('pdfkit');

export default {
  name: "TraAtividadesProgramadasRealizadas",
  components: {
    Header,
  },

  data: function () {
    return {
      mode: "save",
      carregando: false,
      operadores: {},
      operador: [],

      fichaponto: [],
      fichapontoresumofolha: {},
      fichapontom: [],
      fichapontorm: [],
      data_inicial: "",
      data_final: "",

      mainProps: { blankColor: "#777", width: 157, height: 161, class: "m1" },

      fields: [
        {
          key: "foto0",
          label: "Data serviço",
          sortable: false,
          tdClass: "foto-column",
        },
        {
          key: "foto1",
          label: "1ª Batida",
          sortable: false,
          tdClass: "foto-column",
        },
        {
          key: "foto2",
          label: "2ª Batida",
          sortable: false,
          tdClass: "foto-column",
        },
        {
          key: "foto3",
          label: "3ª Batida",
          sortable: false,
          tdClass: "foto-column",
        },
        {
          key: "foto4",
          label: "4ª Batida",
          sortable: false,
          tdClass: "foto-column",
        },
        {
          key: "foto5",
          label: "5ª Batida",
          sortable: false,
          tdClass: "foto-column",
        },
        {
          key: "foto6",
          label: "6ª Batida",
          sortable: false,
          tdClass: "foto-column",
        },
        {
          key: "foto7",
          label: "7ª Batida",
          sortable: false,
          tdClass: "foto-column",
        },
        {
          key: "foto8",
          label: "8ª Batida",
          sortable: false,
          tdClass: "foto-column",
        },
      ],
    };
  },

  computed: mapState(["user"]),

  methods: {
    setInitialAndFinalDates() {
      const now = new Date();

      // Primeiro dia do mês
      const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
      // Último dia do mês
      const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

      this.data_inicial = firstDay.toISOString().substr(0, 10);
      this.data_final = lastDay.toISOString().substr(0, 10);
    },

    async getBase64FromImageUrl(imageUrl) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.setAttribute("crossOrigin", "anonymous");
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          const dataURL = canvas.toDataURL("image/jpeg");
          resolve(dataURL);
        };
        img.onerror = (error) => reject(error);
        img.src = imageUrl;
      });
    },

    async gerarPDFLesser() {
      try {
        const doc = new jsPDF();

        const startX = 14;
        const startY = 10;

        const fontSize = 8; // Defina o tamanho da fonte desejado

        doc.setFontSize(fontSize); // Define o tamanho da fonte para todos os textos seguintes

        doc.text(
          this.operador.nomeempresarial
            ? this.operador.nomeempresarial
            : "Parametrizar o nome da empresa",
          startX,
          startY + 3,
          {
            align: "left",
          }
        );

        doc.text(
          "Registro: " + (this.operador.registro || ""),
          startX,
          startY + 8,
          {
            align: "left",
          }
        );
        doc.text(
          "Nome: " + (this.operador.nome_completo || ""),
          startX,
          startY + 12,
          {
            align: "left",
          }
        );
        doc.text(
          "Função: " + (this.operador.funcao || ""),
          startX,
          startY + 16,
          {
            align: "left",
          }
        );

        doc.text(
          "Data inicial: " +
            moment(this.data_inicial).format("DD/MM/YYYY") +
            " - Data final: " +
            moment(this.data_final).format("DD/MM/YYYY"),
          startX,
          startY + 20,
          { align: "left" }
        );

        // Se desejar voltar ao tamanho de fonte padrão, você pode usar:
        // doc.setFontSize(16); // ou outro tamanho de fonte padrão que deseje

        // Se desejar voltar à fonte padrão, você pode usar:
        // doc.setFont("helvetica");

        const headers = [
          "Data Serviço",
          "1ª Marcação",
          "2ª Marcação",
          "3ª Marcação",
          "4ª Marcação",
          "5ª Marcação",
          "6ª Marcação",
          "7ª Marcação",
          "8ª Marcação",
        ];

        const dadosParaPDF = [];
        for (const item of this.fichaponto) {
          const rowData = [moment(item.dt_servico).format("DD/MM/YYYY")];
          for (const nsr of item.nsr_array) {
            if (typeof nsr === "string") {
              rowData.push(nsr);
            } else if (Array.isArray(nsr) && typeof nsr[1] === "string") {
              const horarioMarcacao = moment(nsr[0]).format("DD/MM/YYYY HH:mm");
              try {
                const fotoRegistro = await this.getBase64FromImageUrl(nsr[1]);
                // Aqui, ao invés de empurrar diretamente para o array, criamos um objeto com as informações necessárias
                rowData.push({ horario: horarioMarcacao, image: fotoRegistro });
              } catch (error) {
                console.error("Erro ao carregar a imagem:", error);
                rowData.push("Erro ao carregar a imagem");
              }
            } else {
              rowData.push("Erro");
            }
          }
          dadosParaPDF.push(rowData);
        }

        const rowsPerPage = 12;
        for (let i = 0; i < dadosParaPDF.length; i += rowsPerPage) {
          const currentData = dadosParaPDF.slice(i, i + rowsPerPage);

          if (i > 0) {
            doc.addPage();
          }

          doc.autoTable({
            startY: 35,
            head: [headers],
            body: currentData,
            theme: "plain",
            columnStyles: {
              0: { cellWidth: 20 },
              1: { cellWidth: 20 },
              2: { cellWidth: 20 },
              3: { cellWidth: 20 },
              4: { cellWidth: 20 },
              5: { cellWidth: 20 },
              6: { cellWidth: 20 },
              7: { cellWidth: 20 },
              8: { cellWidth: 20 },
            },
            styles: {
              fontSize: 6,
              cellPadding: 2,
              valign: "middle",
              halign: "center",
            },
            headStyles: { fontStyle: "bold" },
            didDrawCell: function (data) {
              const cell = data.cell;
              const doc = data.doc;

              doc.rect(cell.x, cell.y, cell.width, cell.height);

              if (cell.raw && typeof cell.raw === "object") {
                if (cell.raw.image) {
                  const imgWidth = 85.05 * 0.16;
                  const imgHeight = 113.4 * 0.12;
                  const xOffset = (cell.width - imgWidth) / 2;
                  const yOffset = (cell.height - imgHeight) / 2 + 2;

                  const horarioText = cell.raw.horario;
                  doc.text(horarioText, cell.x + cell.width / 2, cell.y + 4, {
                    align: "center",
                  });

                  doc.addImage(
                    cell.raw.image,
                    "JPEG",
                    cell.x + xOffset,
                    cell.y + yOffset + 0,
                    imgWidth,
                    imgHeight
                  );
                } else {
                  const horarioText = cell.raw.horario;
                  doc.text(horarioText, cell.x + cell.width / 2, cell.y + 3, {
                    align: "center",
                  });
                }
              }
            },
            didParseCell: function (data) {
              if (
                data.cell.raw &&
                typeof data.cell.raw === "object" &&
                data.cell.raw.image
              ) {
                data.cell.styles.minCellHeight = 180.4 * 0.1 * 1.1;
              }
            },
          });
        }

        const pageCount = doc.internal.getNumberOfPages();
        const footerFontSize = 6; // Defina o tamanho da fonte para o rodapé

        for (let i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          const footerX = 10;
          const footerY = doc.internal.pageSize.height - 10;
          const currentDate = moment().format("DD/MM/YYYY - HH:mm");
          const pageNumber = "Página " + i + " de " + pageCount;
          const footerText = "Data: " + currentDate + " | " + pageNumber;

          doc.setFontSize(footerFontSize); // Define o tamanho da fonte
          doc.text(footerText, footerX, footerY);

          // Verifica se estamos na última página
          if (i === pageCount) {
            const assinaturaY = footerY - 10; // Ajuste conforme necessário
            doc.text(
              "____________________________________________________________________",
              footerX,
              assinaturaY - 5
            );
            doc.text(
              "Assinatura: " + this.operador.nome_completo,
              footerX,
              assinaturaY
            );
          }
        }

        doc.save(
          "ficha_ponto_" +
            this.operador.registro +
            "_ periodo_" +
            moment(this.data_inicial).format("DD-MM-YYYY") +
            "_ate_" +
            moment(this.data_final).format("DD-MM-YYYY") +
            ".pdf"
        );
      } catch (error) {
        console.error("Erro ao gerar PDF:", error);
      }
    },

    async loadOperador() {
      let params = {
        psg: this.user.psg,
        registro: `${this.registro}`,
        id_empresa: `${this.user.id_empresa}`,
      };

      const url = `${baseApiUrl}/glo/escala/consulta`;
      axios.get(url, { params }).then((res) => {
        this.operador = res.data;
      });
      this.carregando = false;
      this.fichaponto = [];
    },

    async loadFichaPonto() {
      let params = {
        psg: this.user.psg,
        id_funcionario: `${this.operador.id_funcionario}`,
        dt_inicio: `${moment(this.data_inicial).format("YYYY-MM-DD")}`,
        dt_termino: `${moment(this.data_final).format("YYYY-MM-DD")}`,
      };

      const url = `${baseApiUrl}/pontoeletronico/frq/fichaponto`;
      axios
        .get(url, { params })
        .then((res) => {
          this.carregando = false;
          this.fichaponto = res.data;
          //this.loadFichaPontoSeparador()
        })
        .catch(showError);
    },

    //06/07/2023 23:17h
    async loadFichaPontoResumoFolha() {
      let corpo = {
        ID_FUNCIONARIO_ERP: `${this.operador.id_funcionario_erp}`,
        COMPETENCIA: `${moment(this.data_final).format("MM/YYYY")}`,
      };

      const url = `${baseApiUrl}/orc/pon/pontoresumofolha`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.carregando = false;
          this.fichapontoresumofolha = res.data;
          this.loadFichaPontoSeparadorrm();
        })
        .catch(showError);
    },

    loadFichaPontoSeparador(fichaponto) {
      this.fichapontom = { ...fichaponto };
    },

    loadFichaPontoSeparadorrm(fichapontoresumofolha) {
      this.fichapontorm = { ...fichapontoresumofolha };
    },

    somarTempos(tempo1, tempo2) {
      var array1 = tempo1.split(":");
      var tempo_seg1 =
        parseInt(array1[0]) * 3600 +
        parseInt(array1[1]) * 60 +
        parseInt(array1[2]);
      var array2 = tempo2.split(":");
      var tempo_seg2 =
        parseInt(array2[0]) * 3600 +
        parseInt(array2[1]) * 60 +
        parseInt(array2[2]);
      var tempofinal = parseInt(tempo_seg1) + parseInt(tempo_seg2);
      var hours = Math.floor(tempofinal / (60 * 60));
      var divisorMinutos = tempofinal % (60 * 60);
      var minutes = Math.floor(divisorMinutos / 60);
      var divisorSeconds = divisorMinutos % 60;
      var seconds = Math.ceil(divisorSeconds);
      var contador = "";
      if (hours < 10) {
        contador = "0" + hours + ":";
      } else {
        contador = hours + ":";
      }
      if (minutes < 10) {
        contador += "0" + minutes + ":";
      } else {
        contador += minutes + ":";
      }
      if (seconds < 10) {
        contador += "0" + seconds;
      } else {
        contador += seconds;
      }
      return contador;
    },
  },

  created() {
    this.setInitialAndFinalDates();
  },

  beforeCreate() {
    this.somarTempos();
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
#tblfotos {
  border: 0.25px solid black;
}

#tblfotos td {
  border: 0.25px solid black;
}

#tblfotos th {
  border: 0.25px solid black;
}
</style>

